module.exports = __webpack_public_path__ + "static/media/environmental.aa6f7062.jpg";